import Select from './Select';
import Option from './Option';
export default function getTypedSelectComponents() {
  return {
    Select: Select,
    Option: Option
  };
}